import * as S from './style';

const ScrollMouseMUI = () => (
  <S.ScrollContainer>
    <S.MouseShape>
      <S.Wheel />
    </S.MouseShape>
  </S.ScrollContainer>
);

export default ScrollMouseMUI;